"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxLabelIncidentStatus = exports.BoxLabelIncidentReason = void 0;
var BoxLabelIncidentReason;
(function (BoxLabelIncidentReason) {
    BoxLabelIncidentReason["DUPLICATE_LABEL"] = "DUPLICATE_LABEL";
    BoxLabelIncidentReason["MISSING_LABEL"] = "MISSING_LABEL";
})(BoxLabelIncidentReason = exports.BoxLabelIncidentReason || (exports.BoxLabelIncidentReason = {}));
var BoxLabelIncidentStatus;
(function (BoxLabelIncidentStatus) {
    BoxLabelIncidentStatus["CREATED"] = "CREATED";
    BoxLabelIncidentStatus["NEEDS_BARCODE"] = "NEEDS_BARCODE";
    BoxLabelIncidentStatus["NEEDS_QTY"] = "NEEDS_QTY";
    BoxLabelIncidentStatus["SOLVABLE"] = "SOLVABLE";
    BoxLabelIncidentStatus["SOLVED"] = "SOLVED";
    BoxLabelIncidentStatus["NON_MATCHING"] = "NON_MATCHING";
    BoxLabelIncidentStatus["NEEDS_NUM_PACKAGES"] = "NEEDS_NUM_PACKAGES";
})(BoxLabelIncidentStatus = exports.BoxLabelIncidentStatus || (exports.BoxLabelIncidentStatus = {}));
//# sourceMappingURL=BoxLabelIncident.js.map